import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchCasinoConfig, type FetchCasinoConfigParams } from '../../api/fetchers/casinoConfig/fetcher';

interface FetchCasinoConfigActionParams extends FetchCasinoConfigParams {
  essential: boolean;
  language?: string;
}

export const fetchCasinoConfigAction = createAsyncThunk(
  'casinoConfig/fetchCasinoConfig',
  (params: FetchCasinoConfigActionParams) => fetchCasinoConfig(params)
);
